import type { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

type ProjectCreationShellProps = {
  title?: ReactNode;
  onClose?: () => void;
  closeDisabled?: boolean;
  hideCloseButton?: boolean;
  hideDefaultHeader?: boolean;
  customHeader?: ReactNode;
  children?: ReactNode;
  footerLeft?: ReactNode;
  footerRight?: ReactNode;
  hidden?: boolean;
};

const shellStyle = {
  main: 'project-creation-shell relative p-8 pt-6 bg-white rounded-b md:rounded',
  header: 'project-creation-shell__header w-full pb-4 mb-4 bg-transparent flex',
  name: 'text-xl flex-grow',
  article: 'project-creation-shell__article relative',
};

const ProjectCreationShell = ({
  title,
  onClose,
  closeDisabled = false,
  hideCloseButton = false,
  hideDefaultHeader = false,
  customHeader = null,
  children,
  footerLeft = null,
  footerRight = null,
  hidden = false,
}: ProjectCreationShellProps) => {
  return (
    <>
      <section
        className={`${shellStyle.main} onboarding-container-section project-creation-flow-section`}
        hidden={hidden}
      >
        {!hideDefaultHeader && (
          <header className={shellStyle.header}>
            <h2 className={shellStyle.name}>{title}</h2>
            <div className="project-creation-shell__header-action" aria-hidden={hideCloseButton ? true : undefined}>
              {onClose ? (
                <IconButton
                  size="large"
                  className="exit-icon"
                  onClick={onClose}
                  disabled={closeDisabled}
                  style={hideCloseButton ? { visibility: 'hidden', pointerEvents: 'none' } : undefined}
                  aria-hidden={hideCloseButton ? true : undefined}
                  tabIndex={hideCloseButton ? -1 : undefined}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </div>
          </header>
        )}

        {customHeader}

        <article className={shellStyle.article}>{children}</article>
        <nav className="onboarding-nav project-creation-shell__nav">
          <div className="onboarding-nav-left">{footerLeft}</div>
          <div className="onboarding-nav-right">{footerRight}</div>
        </nav>
      </section>
    </>
  );
};

export default ProjectCreationShell;
